import { SvgIcon, type SvgIconProps } from '../layout/SvgIcon';

export const FlashcardIcon24 = (props: SvgIconProps) => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path d="M17.75 4.25c.966 0 1.75.784 1.75 1.75v9a1.75 1.75 0 0 1-1.75 1.75h-15A1.75 1.75 0 0 1 1 15V6c0-.966.784-1.75 1.75-1.75h15ZM18 6a.25.25 0 0 0-.25-.25h-15A.25.25 0 0 0 2.5 6v9c0 .138.112.25.25.25h15A.25.25 0 0 0 18 15V6Z" />
        <path d="M21.75 8.25c.966 0 1.75.784 1.75 1.75v9a1.75 1.75 0 0 1-1.75 1.75h-15A1.75 1.75 0 0 1 5 19v-3a.75.75 0 0 1 1.5 0v3c0 .138.112.25.25.25h15A.25.25 0 0 0 22 19v-9a.25.25 0 0 0-.25-.25h-3a.75.75 0 0 1 0-1.5h3Z" />
        <path d="M4.75 10.25a.75.75 0 0 1 .75-.75H15a.75.75 0 0 1 0 1.5H5.5a.75.75 0 0 1-.75-.75Z" />
    </SvgIcon>
);
